<template>
  <section :class="[ 'detail-section', section.classes ]" :data-section-index="idx">
    <div :class="[ 'content', { 'fade-in': showContent } ]">
      <div :class="[ 'detail-instructions', { active: showOverlay } ]">
        <p
          class="font-regular text-size-35 fg-white"
          v-html="section.instructions"
        ></p>
        <div class="icon"></div>
      </div>

      <Transition>
        <div v-if="showContent && showOverlay" class="overlay">
          <div
            v-for="item in section.items"
            :key="item.index"
            :class="[ 'focusable', item.classes, { active: focus && focus.index === item.index} ]"
            :style="getItemStyle(item)"
            @click.prevent="showFocus(item)"
          >
            <div class="image-wrapper">
              <img :src="item.source" :alt="item.label" draggable="false">
            </div>
            <div
              :class="[ 'label', `label-${item['label-position']}` ]"
            >
              <span v-html="item.label"></span>
              <div v-if="item.indicator" class="lines">
                <div class="line line-root node-start">
                  <div class="line line-tail node-end"></div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="section.continue" class="continue">
            <p class="font-semibold text-size-33 fg-white" v-html="section.continue"></p>
          </div>
        </div>
        <component
          v-if="detail && showDetail"
          :is="detail.type"
          :section="detail"
          :idx="`t_${detail.index}`"
        />
      </Transition>
    </div>
    
    <div
      :class="[ 'button', 'button-navigation', 'button-next', { active: showBackButton } ]"
      @click.prevent="onClick"
    ></div>
  </section>
</template>
  
<script>
import ContentSection from './ContentSection'
import DetailDisplay from '../partials/DetailDisplay'

export default {
  name: 'PathwayDetail',
  components: {
    ContentSection,
    DetailDisplay
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    idx: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showContent: false,
      showOverlay: false,
      showDetail: false,
      showBackButton: false,
      focus: null,
      detail: null,

      eventHandlers: {},
    }
  },
  methods: {
    getItemStyle(item) {
      const properties = [ 'top', 'left', 'width', 'height' ];
      let style = '';
      properties.forEach(prop => {
        if (item[prop] !== undefined) {
          style += `${prop}:${item[prop]}rem;`
        }
      });
      return style;
    },

    onAction(event) {
      if (event.type in this.eventHandlers) {
        return this.eventHandlers[event.type](event);
      }
      this.$emit('action', event);
    },
    activateState() {
      this.showContent = true;
      this.showOverlay = true;
      this.$emit('action', { type: 'setNextButtonState', data: true });
    },
    showFocus(item) {
      this.focus = item;
      if (item.detail) {
        this.detail = item.detail;
        setTimeout(() => this.showDetail = true, this.detail.delay * 1000);
      }
      this.showOverlay = false;
      this.$emit('action', { type: 'setNextButtonState', data: false });

      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: item.open,
          onEnded: () => this.openChapterEnded(),
        }
      });
    },
    openChapterEnded() {
      if (this.focus.continuous) {
        this.$emit('action', {
          type: 'playChapter', data: {
            chapter: this.focus.close,
            onEnded: () => this.onChapterEnded(),
          }
        });
      } else {
        this.setBackButton(true);
      }
    },
    setBackButton(state) {
      this.showBackButton = state;
    },
    setDetailState(state) {
      this.showDetail = state;
    },
    onChapterEnded() {
      this.focus = null;
      this.detail = null;
      this.showOverlay = true;
      this.showDetail = false;
      if (this.section.menu) {
        this.$emit('action', { type: 'playChapter', data: this.section.menu });
      }
      this.$emit('action', { type: 'setNextButtonState', data: true });
    },
    onClick() {
      this.showDetail = false;
      this.showBackButton = false;
      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: this.focus.close,
          onEnded: () => this.onChapterEnded(),
        }
      });
    }
  },
  mounted() {
    if (this.section.chapter !== null) {
      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: this.section.chapter,
          onEnded: () => this.activateState(),
        }
      });
    } else {
      this.activateState();
    }
    this.$emit('action', { type: 'updateHeader', data: this.section['header-color'] });
  },
}
</script>
